/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Card, Form, Row, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import moment from 'moment';
import { outOfNavRoutes } from '../../utils/constants/routes';
import useAuthContext from '../../contexts/AuthContext';
import useFields from './fields';
import useGenerateFormItem from '../../utils/GenerateFormItem';
import useErrorMessage from '../../utils/ErrorMessage';
import {
  formItemLayout,
  tailFormItemLayout
} from '../../utils/constants/formLayout';
import PageHeader from '../../components/PageHeader/PageHeader';

const UpdateProfile = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { message } = useErrorMessage();
  const { dispatchAPI, setUser } = useAuthContext();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { fields } = useFields();
  const generateFields = useGenerateFormItem();
  const [form] = Form.useForm();

  const fetchUser = useCallback(async () => {
    setIsLoading(true);
    try {
      const { data } = await dispatchAPI('GET', {
        url: `/users/${id}?populate=insurer`
      });
      form.setFieldsValue({
        ...data,
        date_of_birth: data.date_of_birth && moment(data.date_of_birth)
      });
      setUser(data);
    } catch (e) {
      message(e);
    }
    setIsLoading(false);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchUser();
    // eslint-disable-next-line
  }, [fetchUser]);

  const updateProfile = async (body) => {
    try {
      await dispatchAPI('PATCH', { url: `/users/${id}`, body });
      await fetchUser();
      navigate(outOfNavRoutes.PROFILE);
    } catch (e) {
      if (e.response) message(e.response.status);
    }
  };

  const handleSubmit = async (values) => {
    await updateProfile(values);
  };

  return (
    <>
      <PageHeader title={t('profile.edit.title')} />
      <Card>
        <Spin spinning={isLoading}>
          <Form form={form} onFinish={handleSubmit} {...formItemLayout}>
            {fields.map((field) => generateFields('users', field))}
            <Form.Item {...tailFormItemLayout}>
              <Row justify="end">
                <Button
                  style={{ margin: '0 10px' }}
                  type="link"
                  danger
                  onClick={() => navigate(-1)}
                >
                  {`${t('buttons.cancel')} `}
                  <CloseOutlined />
                </Button>
                <Button type="add" htmlType="submit">
                  {`${t('buttons.save')} `}
                  <CheckOutlined />
                </Button>
              </Row>
            </Form.Item>
          </Form>
        </Spin>
      </Card>
    </>
  );
};

export default UpdateProfile;
